import { setRetailerDashboardType } from 'auth/actions/session.actions';
import { setDashboardSubtype } from 'retailer-dashboards/actions/retailer-dashboards.actions';
import { checkAccess } from 'app/actions/app.actions';
import RetailerDashboardPageTemplate from './retailer-dashboard-page.html';

const mapStateToThis = ({ retailerDashboards, dictionary, session, retailerDetails }) => {
  const { locale } = session;
  const { type, subtype, sessionId } = retailerDashboards;
  const terms = dictionary.terms[locale];

  return {
    type,
    subtype,
    sessionId,
    terms,
    retailerDetails,
  };
};

const mapDispatchToThis = {
  setRetailerDashboardType,
  setDashboardSubtype,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state')
class RetailerDashboardPageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (!this.type || !this.subtype) {
      this.$state.go('retailerWidgets-view');
    }
    this.hasAccessToSummaryDashboard = this.checkAccess('dashboard.summary');
    this.hasAccessToInstantDashboard = this.checkAccess('dashboard.instant');
    this.summaryDashboardLabel = this.gettextCatalog.getString('Summary Dashboard');
    /// {{ instant }} is Lottery term using to determine Instant games.
    this.instantsDashboardLabel = this.gettextCatalog.getString('{{ instant }} Dashboard', { instant: this.terms.INSTANT.plural });
    this.retailerId = this.$state.params.retailerNo;
    this.setRetailerDashboardType(this.type, this.sessionId).then(() => {
      this.showDashboard = true;
    });
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onTabSelect(tab) {
    this.showDashboard = false;
    this.setDashboardSubtype(tab);
    this.$state.reload();
  }
}

class RetailerDashboardPageComponent {
  constructor() {
    this.template = RetailerDashboardPageTemplate;
    this.controller = RetailerDashboardPageController;
    return this;
  }
}

export default RetailerDashboardPageComponent;



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/containers/dashboard-page/retailer-dashboard-page-component.js